import * as THREE from "three";
import { Vector2 } from "three";

function CardTexture(texture) {

    const faceTexture = new THREE.TextureLoader().load(texture);
    faceTexture.center = new Vector2(0.5, 0.5);
    faceTexture.wrapS = THREE.RepeatWrapping;
    faceTexture.wrapT = THREE.RepeatWrapping;
    faceTexture.flipY = false;
    return faceTexture;
}

export default CardTexture;